import {CompanyInfoType, CompanyMemberElementType, CompanyMemberMapType, CompanySearchParamType} from "../interface";

export const companySearchParamInit: CompanySearchParamType = {
    keyword: "",
    keywordType: "0",
    limit: 10,
    pageNo: 1,
    userId: 0,
}

export const companyInfoInit: CompanyInfoType = {
    accountId: '',
    businessRegNo: '',
    businessFileInfo: {
        fileId: 0,
        fileKey: '',
        fileOrgname: '',
        fileType: '',
        fileUrl: '',
    },
    contactPersonName: '',
    exchangeRateCondition1: 0,
    exchangeRateCondition2: 0,
    exchangeRateCondition3: 0,
    exchangeRateUnit: 0,
    location: '',
    name: '',
    newTxtDcAds1H: '',
    newTxtNameEng: '',
    newTxtNmCeo: '',
    taxInvoicePerson: '',
    wonUnit: 0,
};

export const companyMemberMapInit: CompanyMemberMapType = {
    totalCount: 0,
    userList: []
}

export const companyMemberElementInit: CompanyMemberElementType = {
    userId: 0,
    loginId: '',
    contactNo: '',
    crmId: '',
    password: '',
    userName: '',
    title: '',
    phoneNo: '',
    extensionNo: '',
    companyId: '',
    companyName: '',
    coEmail: '',
    remark: '',
    departmentId: '',
    departmentName: '',
    teamId: '',
    teamName: '',
    positionId: 0,
    dutyGroupId: 0,
    modAt: '',
    regAt: '',
    deleteFlag: '',
    dutyGroupName: '',
    roleName: '',
    dutyGroupTypeName: '',
    orgName: '',
    inOutFlag: 0,
};